import axios from '../../utils/axios-whe';

export const GET_BOARD_MEMBERS_START = 'get_board_members_start';
export const GET_BOARD_MEMBERS_SUCCESS = 'get_board_members_success';
export const GET_BOARD_MEMBERS_FAILED = 'get_board_members_failed';

export const GET_BOARD_MEMBER_START = 'get_board_member_start';
export const GET_BOARD_MEMBER_SUCCESS = 'get_board_member_success';
export const GET_BOARD_MEMBER_FAILED = 'get_board_member_failed';

export const ADD_BOARD_MEMBER_START = 'add_board_member_start';
export const ADD_BOARD_MEMBER_SUCCESS = 'add_board_member_success';
export const ADD_BOARD_MEMBER_FAILED = 'add_board_member_failed';

export const UPDATE_BOARD_MEMBER_START = 'update_board_member_start';
export const UPDATE_BOARD_MEMBER_SUCCESS = 'update_board_member_success';
export const UPDATE_BOARD_MEMBER_FAILED = 'update_board_member_failed';

export const DELETE_BOARD_MEMBER_START = 'delete_board_member_start';
export const DELETE_BOARD_MEMBER_SUCCESS = 'delete_board_member_success';
export const DELETE_BOARD_MEMBER_FAILED = 'delete_board_member_failed';

export const GET_COMMITTEES_START = 'get_committees_start';
export const GET_COMMITTEES_SUCCESS = 'get_committees_success';
export const GET_COMMITTEES_FAILED = 'get_committees_failed';

export const ADD_COMMITTEE_MEMBER_START = 'add_committee_member_start';
export const ADD_COMMITTEE_MEMBER_SUCCESS = 'add_committee_member_success';
export const ADD_COMMITTEE_MEMBER_FAILED = 'add_committee_member_failed';

export const REMOVE_COMMITTEE_MEMBER_START = 'remove_committee_member_start';
export const REMOVE_COMMITTEE_MEMBER_SUCCESS = 'remove_committee_member_success';
export const REMOVE_COMMITTEE_MEMBER_FAILED = 'remove_committee_member_failed';

export const GET_BOARD_N_COMMITTEES_START = 'get_board_n_committees_start';
export const GET_BOARD_N_COMMITTEES_SUCCESS = 'get_board_n_committees_success';
export const GET_BOARD_N_COMMITTEES_FAILED = 'get_board_n_committees_failed';

export const ADD_COMMITTEE_START = 'add_committee_start';
export const ADD_COMMITTEE_SUCCESS = 'add_committee_success';
export const ADD_COMMITTEE_FAILED = 'add_committee_failed';

export const UPDATE_COMMITTEE_START = 'update_committee_start';
export const UPDATE_COMMITTEE_SUCCESS = 'update_committee_success';
export const UPDATE_COMMITTEE_FAILED = 'update_committee_failed';

export const DELETE_COMMITTEE_START = 'delete_committee_start';
export const DELETE_COMMITTEE_SUCCESS = 'delete_committee_success';
export const DELETE_COMMITTEE_FAILED = 'delete_committee_failed';

const errorText = (error) => {
  let errText = error.message;
  if (error.response?.status === 404 && error.response?.data?.error) {
    errText = error.response.data.error;
  }
  return errText;
}

export const getBoardMembers = () => {
  return async (dispatch, getState) => {
    const auth = getState().auth;
    dispatch({ type: GET_BOARD_MEMBERS_START, payload: {} });
    try {
      let response = await axios.get('/api_v1/board_members.json?s=a', {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Token ${auth.token}`,
          'X-CSRF-Token': auth.csrf_token
        }
      });
      console.log(response);
      dispatch({ type: GET_BOARD_MEMBERS_SUCCESS, payload: { board_members: response.data }})
    } catch (error) {
      console.log(`ERROR: ${error}`);
      dispatch({ type: GET_BOARD_MEMBERS_FAILED, payload: {error: errorText(error)} });
    }
  }
};

export const getBoardMember = (boardMemberId) => {
  return async (dispatch, getState) => {
    const auth = getState().auth;
    dispatch({ type: GET_BOARD_MEMBER_START, payload: {} });
    try {
      let response = await axios.get(`/api_v1/board_members/${boardMemberId}.json`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Token ${auth.token}`,
          'X-CSRF-Token': auth.csrf_token
        }
      });
      console.log(response);
      dispatch({ type: GET_BOARD_MEMBER_SUCCESS, payload: { board_member: response.data }})
    } catch (error) {
      console.log(`ERROR: ${error}`);
      dispatch({ type: GET_BOARD_MEMBER_FAILED, payload: {error: errorText(error)} });
    }
  }
}

export const addBoardMember = (boardMember) => {
  const formJson = {
    "board_member": {...boardMember }
  };

  return (dispatch, getState) => {
    const auth = getState().auth;

    dispatch({type: ADD_BOARD_MEMBER_START});
    axios.post(`/api_v1/board_members.json`, formJson,
    {
      _method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Token ${auth.token}`,
        'X-CSRF-Token': auth.csrf_token
      }
    })
    .then(response => {
      console.log(`boardMemberActions: addBoardMember`, response.data);
      dispatch({type: ADD_BOARD_MEMBER_SUCCESS, payload: {board_member: response.data}});
    })
    .catch(error => {
      alert(`ERROR updating boardMember.  ${error}`)
      dispatch({type: ADD_BOARD_MEMBER_FAILED, payload: { error: errorText(error) }})
    })
  }
}

export const updateBoardMember = (boardMember) => {
  const formJson = {
    "board_member": {...boardMember }
  };

  return (dispatch, getState) => {
    const auth = getState().auth;

    dispatch({type: UPDATE_BOARD_MEMBER_START});
    axios.patch(`/api_v1/board_members/${boardMember.id}.json`, formJson,
    {
      _method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Token ${auth.token}`,
        'X-CSRF-Token': auth.csrf_token
      }
    })
    .then(response => {
      console.log(`boardMemberActions: updateBoardMember`, response.data);
      dispatch({type: UPDATE_BOARD_MEMBER_SUCCESS, payload: {board_member: response.data}});
    })
    .catch(error => {
      alert(`ERROR updating address info.  ${error}`)
      dispatch({type: UPDATE_BOARD_MEMBER_FAILED, payload: { error: errorText(error) }})
    })
  }
}

export const deleteBoardMember = (boardMemberId) => {
  return async (dispatch, getState) => {
    const auth = getState().auth;
    dispatch({ type: DELETE_BOARD_MEMBER_START, payload: {} });
    try {
      await axios.delete(`/api_v1/board_members/${boardMemberId}.json`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Token ${auth.token}`,
          'X-CSRF-Token': auth.csrf_token
        }
      })
      dispatch({ type: DELETE_BOARD_MEMBER_SUCCESS, payload: {} });
    } catch (error) {
      alert(`ERROR deleting board member ${boardMemberId}.  ${error}`)
      dispatch({type: DELETE_BOARD_MEMBER_FAILED, payload: { error: errorText(error) }})
    }
  }
}

export const getBoardCommittees = () => {
  return async (dispatch, getState) => {
    const auth = getState().auth;
    dispatch({ type: GET_COMMITTEES_START, payload: {} });
    try {
      let response = await axios.get('/api_v1/committees.json?s=a&is_board=true', {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Token ${auth.token}`,
          'X-CSRF-Token': auth.csrf_token
        }
      });
      console.log(response);
      dispatch({ type: GET_COMMITTEES_SUCCESS, payload: { committees: response.data }})
    } catch (error) {
      console.log(`ERROR: ${error}`);
      dispatch({ type: GET_COMMITTEES_FAILED, payload: {error: errorText(error)} });
    }
  }
}

export const addCommitteeMember = (committeeId, userId, isChair) => {
  const formJson = {
    "user_id": userId,
    "committee_id": committeeId,
    "is_chair": isChair
  };

  return (dispatch, getState) => {
    const auth = getState().auth;

    dispatch({type: ADD_COMMITTEE_MEMBER_START});
    axios.post(`/api_v1/committees/${committeeId}/add_member.json`, formJson,
    {
      _method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Token ${auth.token}`,
        'X-CSRF-Token': auth.csrf_token
      }
    })
    .then(response => {
      console.log(`boardMemberActions: addCommitteeMember`, response.data);
      dispatch({type: ADD_COMMITTEE_MEMBER_SUCCESS, payload: {board_member: response.data}});
    })
    .catch(error => {
      alert(`ERROR adding committee member.  ${error}`)
      dispatch({type: ADD_COMMITTEE_MEMBER_FAILED, payload: { error: errorText(error) }})
    })
  }
}

export const removeCommitteeMember = (committeeId, userId) => {
  const formJson = {
     "user_id": userId
  };

  return (dispatch, getState) => {
    const auth = getState().auth;

    dispatch({type: REMOVE_COMMITTEE_MEMBER_START});
    axios.post(`/api_v1/committees/${committeeId}/remove_member.json`, formJson,
    {
      // _method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Token ${auth.token}`,
        'X-CSRF-Token': auth.csrf_token
      }
    })
    .then(response => {
      console.log(`boardMemberActions: removeCommitteeMember`, response.data);
      dispatch({type: REMOVE_COMMITTEE_MEMBER_SUCCESS, payload: {board_member: response.data}});
    })
    .catch(error => {
      alert(`ERROR removing committee member.  ${error}`)
      dispatch({type: REMOVE_COMMITTEE_MEMBER_FAILED, payload: { error: errorText(error) }})
    })
  }
}

// TEST: See if I can combine BOTH board members and committees into a single op to reduce re-renders
export const getBoardAndCommittees = () => {
  return async (dispatch, getState) => {
    const auth = getState().auth;
    dispatch({ type: GET_BOARD_N_COMMITTEES_START, payload: {} });
    try {
      let responseBoard = await axios.get('/api_v1/board_members.json?s=a', {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Token ${auth.token}`,
          'X-CSRF-Token': auth.csrf_token
        }
      });
      console.log(responseBoard);
 
      let responseCommittees = await axios.get('/api_v1/committees.json?s=a&is_board=true', {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Token ${auth.token}`,
          'X-CSRF-Token': auth.csrf_token
        }
      });
      console.log(responseCommittees);
      dispatch({ type: GET_BOARD_N_COMMITTEES_SUCCESS, payload: { board_members: responseBoard.data, committees: responseCommittees.data }})

    } catch (error) {
      console.log(`ERROR: ${error}`);
      dispatch({ type: GET_BOARD_N_COMMITTEES_FAILED, payload: {error: errorText(error)} });
    }
  }
}

export const addCommittee = (committee) => {
  const formJson = {
    "committee": {...committee }
  };

  return (dispatch, getState) => {
    const auth = getState().auth;

    dispatch({type: ADD_COMMITTEE_START});
    axios.post(`/api_v1/committees.json`, formJson,
    {
      _method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Token ${auth.token}`,
        'X-CSRF-Token': auth.csrf_token
      }
    })
    .then(response => {
      console.log(`boardMemberActions: addCommittee`, response.data);
      dispatch({type: ADD_COMMITTEE_SUCCESS, payload: {committee: response.data}});
    })
    .catch(error => {
      alert(`ERROR adding new committee.  ${error}`)
      dispatch({type: ADD_COMMITTEE_FAILED, payload: { error: errorText(error) }})
    })
  }
}

export const updateCommittee = (committee) => {
  const formJson = {
    "committee": {...committee }
  };

  return (dispatch, getState) => {
    const auth = getState().auth;

    dispatch({type: UPDATE_COMMITTEE_START});
    axios.patch(`/api_v1/committees/${committee.id}.json`, formJson,
    {
      _method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Token ${auth.token}`,
        'X-CSRF-Token': auth.csrf_token
      }
    })
    .then(response => {
      console.log(`boardMemberActions: updateCommittee`, response.data);
      dispatch({type: UPDATE_COMMITTEE_SUCCESS, payload: {committee: response.data}});
    })
    .catch(error => {
      alert(`ERROR updating committee.  ${error}`)
      dispatch({type: UPDATE_COMMITTEE_FAILED, payload: { error: errorText(error) }})
    })
  }
}

export const deleteCommittee = (committeeId) => {
  return async (dispatch, getState) => {
    const auth = getState().auth;
    dispatch({ type: DELETE_COMMITTEE_START, payload: {} });
    try {
      await axios.delete(`/api_v1/committees/${committeeId}.json`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Token ${auth.token}`,
          'X-CSRF-Token': auth.csrf_token
        }
      })
      dispatch({ type: DELETE_COMMITTEE_SUCCESS, payload: {} });
    } catch (error) {
      alert(`ERROR deleting committee ${committeeId}.  ${error}`)
      dispatch({type: DELETE_COMMITTEE_FAILED, payload: { error: errorText(error) }})
    }
  }
}
